import { Space } from 'antd';
import { DesignProps } from 'api/DesignApi';
import { FileMessage, Message, MessageTypeEnum } from 'api/MessagesApi';
import DownloadLink from 'components/Message/DownloadLink/DownloadLink';
import MessageIcon from 'components/Message/MessageIcon';
import { AppAudioPlayer } from 'components/UiKit/Media/AppAudioPlayer';
import { AppVideoPlayer } from 'components/UiKit/Media/AppVideoPlayer';
import { TextToHtmlComponent } from 'components/UiKit/TextToHtmlComponent/TextToHtmlComponent';
import { isAudioFile, isVideoFile } from 'utils/utils';
import './MessageContentPreview.css';

type AllProps = {
  message: Message;
  messageFile?: FileMessage;
  designProps?: DesignProps;
};

export default function MessageContentPreview({ message, messageFile, designProps }: AllProps) {
  const fileName = messageFile?.fileName;

  return (
    <div className="message-content-preview" onClick={(e) => e.stopPropagation()}>
      {fileName ? (
        (() => {
          const fallback = (
            <Space size="small">
              <MessageIcon type={message.type} />
              <DownloadLink
                message={message}
                messageFile={messageFile}
                designProps={designProps}
                text={message.fileName}
              />
            </Space>
          );

          if (message.type === MessageTypeEnum.Video && isVideoFile(fileName)) {
            return <AppVideoPlayer url={messageFile.signedUrl} fileName={fileName} fallback={fallback} />;
          }

          if (message.type === MessageTypeEnum.Audio && isAudioFile(fileName)) {
            return <AppAudioPlayer url={messageFile.signedUrl} fileName={fileName} fallback={fallback} />;
          }

          return fallback;
        })()
      ) : message.type === MessageTypeEnum.Text ? (
        <TextToHtmlComponent text={message.content} />
      ) : null}
    </div>
  );
}
